export default "__VITE_ASSET__6b97daa0__"